import React from "react";
import styles from "./style.module.css";
import moment from "moment";
import numeral from "numeral";

import { Popover, OverlayTrigger, Badge } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCalendarAlt, faCalendarDay, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem, Icon } from "aible";

import TileEditIcon from "images/Next-Icons/TileEditIcon.svg";
import TilePinIcon from "images/Next-Icons/TilePinIcon.svg";
import TileTodoIcon from "images/Next-Icons/TileTodoIcon.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import HexGridContainer from "containers/Next/HexGrid";
import MonitoringSummaryContainer from "containers/Next/Monitoring/MonitoringSummary";

import { getConversationArray } from "containers/ChatGPT/reducer";
import { isEnabled } from "utils/featureFlags";

export default class ExplorationTile extends React.PureComponent {
  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  getChatMetrics() {
    const { data, getChatMetrics } = this.props;

    const conversations = data?.metadata?.chatGPTConvo?.conversation;
    const convArr = getConversationArray(undefined, conversations);

    return getChatMetrics(convArr);
  }

  renderMinimap() {
    const { data } = this.props;

    const buildExplores = data?.metadata?.explorations
      ? Object.keys(data?.metadata?.explorations)
          .filter((eKey) => data?.metadata?.explorations[eKey]?.gridType !== undefined)
          .map((eKey) => data?.metadata?.explorations[eKey])
      : [];

    const hasExplore = buildExplores.length > 0;
    const exploreCount =
      data?.metadata?.explorations?.[0]?.hexMap && data?.metadata?.explorations?.[0]?.savedHexMap
        ? Object.keys(data?.metadata?.explorations?.[0]?.hexMap).length +
          Object.keys(data?.metadata?.explorations?.[0]?.savedHexMap).length
        : 0;
    const exploreSavedCount = data?.metadata?.explorations?.[0]?.pinnedHexList
      ? data?.metadata?.explorations?.[0]?.pinnedHexList.length
      : 0;

    const hasProjects = data?.projects ? Object.keys(data?.projects).length > 0 : false;
    const projectTodoCount = data?.metadata?.models?.todos ? Object.keys(data?.metadata?.models?.todos).length : 0;
    const hasMonitor = Boolean(data?.metadata?.monitoring?.monitoringSummary?.data?.length);
    const monitorDaysCount = data?.metadata?.monitoring?.monitoringSummary?.data?.length || 0;
    const monitorLabel = data?.metadata?.monitoring?.monitoringSummary?.label;
    const monitorUnitLabel = data?.metadata?.monitoring?.monitoringSummary?.unitLabel || "";
    const monitorValue = data?.metadata?.monitoring?.monitoringSummary?.data?.[monitorDaysCount - 1]?.[monitorLabel];

    const rowCount = data?.dataset?.rowCount;
    const colCount = data?.dataset?.fields ? Object.keys(data?.dataset?.fields).length : 0;

    const transformCount = data?.metadata?.transforms?.savedHexMap
      ? Object.keys(data?.metadata?.transforms?.savedHexMap).length
      : 0;

    return (
      <div className={styles.minimap} style={{ overflow: "hidden" }}>
        <div className={styles.mapRow}>
          <div className={styles.mapBorder} />
          <div className={styles.mapHolder} style={{ top: "-25px" }}>
            <Badge className={styles.mapBadge} style={{ background: "rgba(113, 188, 116, 1)" }}>
              {"Transform"}
            </Badge>
            <Badge className={styles.mapBadge} style={{ background: "rgba(113, 188, 116, 1)", left: "240px" }}>
              <img src={TileEditIcon} className={styles.tileBadgeIcon} style={{ marginRight: "3px" }} />
              {transformCount}
            </Badge>
            {data?.metadata?.transforms?.hexMap !== undefined && data?.metadata?.transforms?.hexMap !== undefined && (
              <HexGridContainer
                id={data.id}
                isMini
                isTile
                isProjectOverview
                hexMap={{
                  ...data?.metadata?.transforms?.hexMap,
                  ...data?.metadata?.transforms?.savedHexMap
                }}
              />
            )}
          </div>
          <div className={styles.mapHolder} style={{ top: "-25px", right: "160px" }}>
            {hasExplore === true && (
              <Badge className={styles.mapBadge} style={{ background: "rgba(126, 207, 231, 1)", left: "50px" }}>
                {exploreCount + " Charts"}
              </Badge>
            )}
            {hasExplore === true && (
              <Badge className={styles.mapBadge} style={{ background: "rgba(126, 207, 231, 1)", left: "255px" }}>
                <img src={TilePinIcon} className={styles.tileBadgeIcon} style={{ marginRight: "3px" }} />
                {exploreSavedCount}
              </Badge>
            )}
            {hasExplore === false ? (
              <div className={styles.emptyMonitor} style={{ left: "10px" }}>
                {"No Explorations"}
              </div>
            ) : (
              <HexGridContainer
                id={data.id}
                isMini
                isTile
                isProjectOverview
                hexMap={data?.metadata?.explorations?.[0]?.hexMap}
              />
            )}
          </div>
        </div>
        <div className={styles.mapRow}>
          <div className={styles.mapBorder} />
          <div className={styles.mapHolder} style={{ top: "-25px" }}>
            {hasProjects === true && (
              <Badge className={styles.mapBadge} style={{ background: "rgb(126, 105, 215)", left: "38px" }}>
                {"Models"}
              </Badge>
            )}
            {hasProjects === true && (
              <Badge className={styles.mapBadge} style={{ background: "rgb(126, 105, 215)", left: "240px" }}>
                <img src={TileTodoIcon} className={styles.tileBadgeIcon} style={{ marginRight: "3px" }} />
                {projectTodoCount}
              </Badge>
            )}
            {hasProjects === false ? (
              <div className={styles.emptyMonitor}>{"No AI Created"}</div>
            ) : (
              <HexGridContainer
                id={data.id}
                isMini
                isTile
                isProjectOverview
                hexMap={{
                  ...data?.metadata?.models?.hexMap,
                  ...data?.metadata?.models?.savedHexMap
                }}
              />
            )}
          </div>
          <div className={styles.mapHolder} style={{ top: "-25px", right: "160px" }}>
            {hasMonitor === true && (
              <Badge className={styles.mapBadge} style={{ background: "rgba(225, 153, 92, 1)" }}>
                {"Monitor"}
              </Badge>
            )}
            {hasMonitor === true && (
              <Badge
                className={styles.mapBadge}
                style={{
                  background: "rgba(225, 153, 92, 1)",
                  left: "unset",
                  right: "-285px",
                  display: "flex"
                }}
              >
                <div className={styles.mapMonitorUnit}>{monitorUnitLabel}</div>
                {/* <div className={styles.tileBadgeIcon} style={{display: "inline-block"}}>
                  <FontAwesomeIcon icon={faCalendarDay} />
                </div> */}
                {numeral(monitorValue).format("0.[0]a")}
              </Badge>
            )}
            {hasMonitor === false ? (
              <div className={styles.emptyMonitor} style={{ left: "10px" }}>
                {"Monitoring Not Started"}
              </div>
            ) : (
              <div className={styles.monitorChart} style={{ left: "10px" }}>
                <MonitoringSummaryContainer id={data.id} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { data, handleDelete, handleMoveReport, onClick } = this.props;

    const hexMap = data?.metadata?.next?.hexMap || data?.metadata?.hexMap;

    const label = data?.metadata?.explorations?.[0]?.reportLabel || data?.name;

    const hasProject = data?.metadata?.explorations?.[0]?.projectId !== undefined;

    const targetValue = data?.metadata?.explorations?.[0]?.targetColumn;
    const subgroupCol = data?.metadata?.explorations?.[0]?.splitColumn;

    const hasTargetValue = targetValue !== undefined;
    const hasSubgroupCol = subgroupCol !== undefined;

    const { prompts, totalTokens, totalCharacters, totalCost } = this.getChatMetrics();

    const hasChats = false && isEnabled("chat-aible") && Boolean(prompts || totalTokens);

    const hasTokens = totalTokens > 0;
    const hasCharacters = totalCharacters > 0;

    return (
      <div
        className={styles.tileWrapping}
        style={{
          height: isEnabled("chat-aible") ? "550px" : undefined
        }}
      >
        <Tile
          onClick={onClick}
          buttonText={"Open Project"}
          handleDelete={handleDelete ? (e) => this.handleDelete(e) : undefined}
          // TODO: Move folder
          //handleMoveFolder={() => handleMoveReport(data?.id)}
          style={{ width: "auto", height: "auto" }}
        >
          {hasProject && false && <div className={styles.hasProject}>{"Has Models"}</div>}
          <TileTitle title={label} color={"rgb(126, 105, 215)"} icon={"projectSegments"} style={{ color: "white" }}>
            {"(" + data.id + ") " + label}
          </TileTitle>
          {(hasTargetValue || hasSubgroupCol) && (
            <React.Fragment>
              <div className={styles.exploreTitleExtension} style={{ background: "rgb(126, 105, 215)" }} />
              <div className={styles.exploreSubTitle}>
                {hasTargetValue && (
                  <div className={styles.exploreSubTitleContent}>
                    <Icon type={"target"} size={16} />
                    <strong style={{ marginLeft: "6px", marginTop: "2px" }}>{targetValue}</strong>
                  </div>
                )}
                {hasSubgroupCol && (
                  <div className={styles.exploreSubTitleContent}>
                    <Icon type={"pieChart"} size={16} />
                    <span style={{ marginLeft: "6px", marginTop: "2px" }}>{subgroupCol}</span>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
          <TileBody
          // style={{
          //   marginBottom: spacerSize
          // }}
          >
            {this.renderMinimap()}
            {hasChats && (
              <React.Fragment>
                <TileItem icon={"chatLines"}>{prompts + " Prompts"}</TileItem>
                <TileItem icon={"gear"}>
                  {(hasTokens ? totalTokens + " Tokens" : "") +
                    (hasTokens && hasCharacters ? " and " : "") +
                    (hasCharacters ? totalCharacters + " Characters" : "") +
                    " Used"}
                </TileItem>
                <TileItem icon={"money"}>{`$${numeral(totalCost).format("0.00[00]")} Total Cost (estimate)`}</TileItem>
              </React.Fragment>
            )}
            {data?.dataset?.label ? <TileItem icon={"dataset"}>{data?.dataset?.label}</TileItem> : null}
            {hexMap && <TileItem icon={"chart"}>{Object.keys(hexMap).length + " charts"}</TileItem>}
            {data.created_date ? (
              <TileItem
                icon={"calendar"}
                overlay={moment.utc(data.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(data.created_date).local().fromNow()}
              </TileItem>
            ) : (
              ""
            )}
            {data.created_by ? (
              <TileItem icon={"user"}>
                {data.created_by.fullname !== undefined ? data.created_by.fullname : data.created_by}
              </TileItem>
            ) : (
              ""
            )}
          </TileBody>
        </Tile>
      </div>
    );
  }
}
